import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import BasicModal from '@app/components/Modal/BasicModal';
import { modalClose } from '@app/store/modal/actions';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  onModalClose: PropTypes.func,
};

const defaultProps = {
  history: {},
  onModalClose() {},
};

class ExitToEditingDocumentsModal extends Component {
  constructor(props) {
    super(props);
    this.exitTo = this.exitTo.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
  }

  handleModalClose() {
    const { onModalClose } = this.props;
    onModalClose();
  }

  exitTo() {
    const { history, onModalClose } = this.props;
    history.push('/editing-documents');
    onModalClose();
  }

  render() {
    return (
      <BasicModal
        cancelText="취소"
        closeText="나가기"
        content={'입력한 내용이 저장되지 않습니다 \n정말 나가시겠습니까?'}
        title="나가기"
        onCancel={this.handleModalClose}
        onClose={this.exitTo}
      />
    );
  }
}

ExitToEditingDocumentsModal.propTypes = propTypes;
ExitToEditingDocumentsModal.defaultProps = defaultProps;

const mapDispatchToProps = {
  onModalClose: modalClose,
};

export default withRouter(connect(undefined, mapDispatchToProps)(ExitToEditingDocumentsModal));
